export const Download = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M25.4257 14.26L16.0155 23.5576L6.69611 14.2935" stroke="currentColor" stroke-width="2"/>
  <path d="M5 25V29C5 29.5523 5.44772 30 6 30H26C26.5523 30 27 29.5523 27 29V25" stroke="currentColor" stroke-width="2"/>
  <path d="M16 3L16 23" stroke="currentColor" stroke-width="2"/>
</svg>
`;
